import Directions from '../../Controls/Directions.js';
import Experience from '../../Experience.js';
import EventEmitter from '../../Utils/EventEmitter.js';
import Events from '../../Utils/Events.js';

const CLICK_COUNTER_API =
    'https://premiodrivingenergy.terna.it/wp-json/driving/v1/arts-view/';

export default class Item {
    constructor(id, originalPosition, observationPoint) {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.domElement = this.experience.canvas;
        this.id = id;
        this.originalPosition = originalPosition;
        this.observationPoint = observationPoint;
        this.hasFocus = false;

        // Event handling
        this.eventEmitter = new EventEmitter();
    }

    setFocus() {
        this.hasFocus = true;
        // this.eventEmitter.trigger(Events.TRIGGER_MOVEMENT, [Directions.ITEM]);
        this.eventEmitter.trigger(Events.ITEM_HAS_FOCUS, [this]);

        fetch(CLICK_COUNTER_API + this.id).then((response) => response.json());
    }

    // Not used as of now
    removeFocus() {
        this.hasFocus = false;
        this.eventEmitter.trigger(Events.TRIGGER_MOVEMENT, [Directions.BACK]);
        this.eventEmitter.trigger(Events.ITEM_LOST_FOCUS);
    }
}
